<script setup lang="ts">
import { computed, type PropType } from 'vue';
import GaiaText from './GaiaText.vue';
import { gaiaNeutral, gaiaStatus } from '../themes/tokens';

const props = defineProps({
  /** `alert` marks a passage the run flagged — an uncommons finding's text. */
  tone: {
    type: String as PropType<'default' | 'alert'>,
    default: 'default',
  },
  /**
   * Clickable: the passage is a way into the document beside it, so it takes a
   * pointer and a hover. The parent owns what the click does.
   */
  interactive: {
    type: Boolean,
    default: false,
  },
});

const rule = computed(() => (props.tone === 'alert' ? gaiaStatus.alert : gaiaNeutral.borderHover));
const bg = gaiaNeutral.surfaceChild;
const bgHover = gaiaNeutral.surfaceHover;
</script>

<template>
  <!-- A passage lifted out of the document — a result's citation, an uncommons
       finding's text. The rule on the left is what marks it as quoted rather
       than written; `alert` tints that rule for a flagged passage. -->
  <gaia-text
    tag="blockquote"
    size="row"
    tone="text"
    class="gaia-quote"
    :class="{ interactive: props.interactive }"
  >
    <slot />
  </gaia-text>
</template>

<style scoped>
.gaia-quote {
  display: block;
  margin: 0;
  padding: 8px 11px;
  border-left: 3px solid v-bind(rule);
  border-radius: 0 7px 7px 0;
  background: v-bind(bg);
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.gaia-quote.interactive {
  cursor: pointer;
  transition: background 0.15s ease;
}

.gaia-quote.interactive:hover {
  background: v-bind(bgHover);
}
</style>
